// @flow
export default {
  title: 'This page is toast',
  subtitle: 'Sorry, the page you are looking for cannot be accessed',
  toasterAlt: 'Toaster with 404',
  cta: 'Either check the URL, or feel free to ',
  link: 'report the issue',
}
